export default {
	namespaced: true,
	state: {
		// 侧边栏, 菜单
		menuList: [{
				menuId: '1',
				key:'history',
				name: '装箱查询',
				url: "page/history",
				type: 2
			},
			{
				menuId: '2',
				key:'equ',
				name: '设备列表',
				url: "page/equ",
				type: 1
			},
			{
				menuId: '3',
				key:'user',
				name: '用户管理',
				url: "page/user",
				type: 1
			},
			{
				menuId: '4',
				key:'log',
				name: '系统日志',
				url: "page/log",
				type: 1
			},
			{
				menuId: '5',
				key:'config',
				name: '系统配置',
				url: "sys/config",
				type: 1
			}
		],
		// 头部菜单
		menuItem: {},
		menuActiveName: '',
		permissions: [],
		tabsMenuList: [],
	},
	mutations: {
		updateTabsMenuList(state, list) {
			state.tabsMenuList = list
		},
		updateMenuList(state, list) {
			state.menuList = list
		},
		updateMenuItem(state, Item) {
			state.menuItem = Item
		},
		updateMenuActiveName(state, name) {
			state.menuActiveName = name
		},
		updatePermissions(state, permissions) {
			state.permissions = permissions
		},
	}
}